import React, { FC, useContext } from 'react'

import { Grid, Icon } from 'semantic-ui-react'

import { Contacts } from '@/components/Contacts';

import { BackgroundImage, SliderContainer, TextDiv, FlexBlock, At, ThemedHoveredText } from './style';
import { NormalHeader } from '../../pages/main_page/components/style';
import ThemeContext from '@/theme/context'

export const Slider = (props) => {
    const { primaryColor } = useContext(ThemeContext);

    return <SliderContainer>
        <BackgroundImage fluid src={props.background} />
        <Grid stackable>
            <Grid.Row>
                <Grid.Column width={8}>
                    <TextDiv>
                        <FlexBlock><ThemedHoveredText $color={primaryColor}><Icon name="phone" /><a href="tel:+78362383501">+7 8362 38-35-01</a></ThemedHoveredText></FlexBlock>
                        <ThemedHoveredText $color={primaryColor}><At>@</At><a href="mailto:nii.mko@yandex.ru">nii.mko@yandex.ru</a></ThemedHoveredText>
                        <Contacts color={'rgba(0,0,0,.35)'} currentAct={props.currentAct} />
                    </TextDiv>
                    <TextDiv>
                        <NormalHeader>{props.header}</NormalHeader>
                    </TextDiv>
                </Grid.Column>
            </Grid.Row>
        </Grid>
    </SliderContainer>
}